import type { Experiments } from '~/types/abtest'

export const buildAbtestInlineScript = (storageKey: string, experiments: Experiments): string => {
  if (Object.keys(experiments).length === 0) {
    return ''
  }

  return `
  (function(storage_key, experiments) {
    let choices = JSON.parse(localStorage.getItem(storage_key)) || {}
    choices = Object.fromEntries(Object.entries(experiments).map(([key, variants]) => {
      const choice = choices[key] || variants[Math.floor(Math.random() * variants.length)]
      return [key, choice]
    }))
    localStorage.setItem(storage_key, JSON.stringify(choices))
    const ab_test = Object.keys(experiments).map((key) => key + '_' + choices[key]).join('|')
    dataLayer.push({ ab_test });
  })('${storageKey}', ${JSON.stringify(experiments)});
`
}
